function AmountInput(wrapperElement) {
  // --- 要素の選択 ---
  const inputField = wrapperElement.querySelector('.input-field');

  // inputField がなければ、このコンポーネントは機能しないため処理を終了
  if (!inputField) {
    console.error('AmountInput: .input-field element not found within the wrapper.', wrapperElement);
    return;
  }

  const statusText = wrapperElement.querySelector('.owd-amountinput-status');
  const errorText = wrapperElement.querySelector('.owd-amountinput-error');
  const container = wrapperElement.querySelector('.owd-amountinput-container');
  const clearButton = wrapperElement.querySelector('.owd-amountinput-clearbutton');
  const inputAreaInner = wrapperElement.querySelector('.owd-amountinput-inputarea\\:input');

  // --- 状態変数 ---
  let isFocused = false;
  let hasInput = false;
  let isError = false;
  let currentErrorMessage = '';

  /**
   * 現在の状態に基づいてUI要素（エラー表示、クリアボタン、ステータステキスト）を更新
   */
  function _updateUI() {
    if (container && errorText) {
      if (isError) {
        container.classList.add('is-error');
        errorText.textContent = currentErrorMessage;
        errorText.style.display = 'block';
      } else {
        container.classList.remove('is-error');
        errorText.style.display = 'none';
        errorText.textContent = '';
      }
    }

    if (clearButton) {
      clearButton.style.display = hasInput ? 'block' : 'none';
    }

    let statusMessage = '';
    if (isFocused) {
      if (inputAreaInner) {
        inputAreaInner.style.borderWidth = '2px';
      }
      if (isError) {
        statusMessage = 'エラー（入力中）';
      } else if (hasInput) {
        statusMessage = '入力中';
      } else {
        statusMessage = 'フォーカス';
      }
    } else {
      if (inputAreaInner) {
        inputAreaInner.style.borderWidth = '1px';
      }
      if (hasInput) {
        if (isError) {
          statusMessage = 'エラー（入力済み）';
        } else {
          statusMessage = '入力済み';
        }
      } else {
        if (isError) {
          statusMessage = 'エラー（入力前）';
        } else {
          statusMessage = '入力前';
        }
      }
    }

    if (statusText) {
        statusText.textContent = statusMessage;
    }
  }

  /**
   * 入力値のバリデーション実行
   * その後、_updateUIを呼び出し。
   */
  function _validate(isBlurEvent = false) {
    const value = inputField.value.trim();
    hasInput = value !== '';

    let newIsError = false;
    let newErrorMessage = '';

    if (hasInput) {
      if (isNaN(Number(value))) {
        newIsError = true;
        newErrorMessage = '半角数字で入力してください。';
      }
    } else {
      if (isBlurEvent) {
        newIsError = true;
        newErrorMessage = '入力は必須です。';
      }
    }

    isError = newIsError;
    currentErrorMessage = newErrorMessage;
    _updateUI();
  }

  // --- イベントリスナー ---
  inputField.addEventListener('focus', () => {
    isFocused = true;
    _validate(false);
  });

  inputField.addEventListener('blur', () => {
    isFocused = false;
    _validate(true);
  });

  inputField.addEventListener('input', () => {
    _validate(false);
  });

  inputField.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      inputField.blur();
    }
  });

  if (clearButton) {
    clearButton.addEventListener('click', () => {
      inputField.value = '';
      inputField.focus();
      _validate(false);
    });
  }

  // --- 初期化処理 ---
  _validate(false);
}

// 各ラッパー要素に対してAmountInput関数を呼び出し・初期化
function inputAction() {
  const amountInputWrappers = document.querySelectorAll('.owd-amountinput-wrapper');
  amountInputWrappers.forEach(wrapper => {
    AmountInput(wrapper);
  });
}

// ページが完全に読み込まれた後にinputActionを実行
document.addEventListener('DOMContentLoaded', () => {
  inputAction();
});

export { inputAction };
